var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sand-box"},[_c('Tool'),_c('NavBar'),_c('Statement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }